// Cliente de Supabase del panel. SOLO clave pública `anon` (patrón del ERP):
// nada privilegiado vive en el navegador; lo que cada usuario ve lo decide la
// RLS de la base. Sin variables de entorno apunta a la Supabase local.
import { createClient } from "@supabase/supabase-js";

const url = import.meta.env.VITE_SUPABASE_URL ?? "http://127.0.0.1:54331";
const anon = import.meta.env.VITE_SUPABASE_ANON_KEY ?? "";

export const sb = createClient(url, anon, {
  // Chat AI vive en SU propio cajón (`chatai`), no en `public`: el proyecto de
  // Supabase se comparte con otros sistemas de Victorix y `public` ya es de
  // ellos. Sin esta línea, cada `.from("conversaciones")` iría a buscar al
  // cajón del vecino. ⚠️ El esquema además hay que EXPONERLO en Supabase
  // (Settings → API → Exposed schemas), o PostgREST responde 404/PGRST106.
  db: { schema: "chatai" },
  auth: { persistSession: true, autoRefreshToken: true, storageKey: "victorix-chat-ai" },
  realtime: { params: { eventsPerSecond: 10 } },
});

export const configurado = Boolean(anon);
